import { TenantEntity } from '../TenantEntity'

export class Insure extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get uuid() {
    return this._data.uuid
  }
  set uuid(uuid) {
    this._data.uuid = uuid
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get orderGenerateStatus() {
    return this._data.orderGenerateStatus
  }
  set orderGenerateStatus(orderGenerateStatus) {
    this._data.orderGenerateStatus = orderGenerateStatus
  }
  get orderGenerateMessage() {
    return this._data.orderGenerateMessage
  }
  set orderGenerateMessage(orderGenerateMessage) {
    this._data.orderGenerateMessage = orderGenerateMessage
  }
  get orderGenerateDate() {
    return this._data.orderGenerateDate
  }
  set orderGenerateDate(orderGenerateDate) {
    this._data.orderGenerateDate = orderGenerateDate
  }
  get orderCommitDate() {
    return this._data.orderCommitDate
  }
  set orderCommitDate(orderCommitDate) {
    this._data.orderCommitDate = orderCommitDate
  }
  get orderModifyDate() {
    return this._data.orderModifyDate
  }
  set orderModifyDate(orderModifyDate) {
    this._data.orderModifyDate = orderModifyDate
  }
  get policyNo() {
    return this._data.policyNo
  }
  set policyNo(policyNo) {
    this._data.policyNo = policyNo
  }
  get insureNo() {
    return this._data.insureNo
  }
  set insureNo(insureNo) {
    this._data.insureNo = insureNo
  }
  get orderStatus() {
    return this._data.orderStatus
  }
  set orderStatus(orderStatus) {
    this._data.orderStatus = orderStatus
  }
  get premium() {
    return this._data.premium
  }
  set premium(premium) {
    this._data.premium = premium
  }
  get inceptionDate() {
    return this._data.inceptionDate
  }
  set inceptionDate(inceptionDate) {
    this._data.inceptionDate = inceptionDate
  }
  get applicantName() {
    return this._data.applicantName
  }
  set applicantName(applicantName) {
    this._data.applicantName = applicantName
  }
  get applicantEnName() {
    return this._data.applicantEnName
  }
  set applicantEnName(applicantEnName) {
    this._data.applicantEnName = applicantEnName
  }
  get insuredIdx() {
    return this._data.insuredIdx
  }
  set insuredIdx(insuredIdx) {
    this._data.insuredIdx = insuredIdx
  }

  get importExportFlag() {
    return this._data.importExportFlag
  }
  set importExportFlag(importExportFlag) {
    this._data.importExportFlag = importExportFlag
  }
  get invoiceNo() {
    return this._data.invoiceNo
  }
  set invoiceNo(invoiceNo) {
    this._data.invoiceNo = invoiceNo
  }
  get eachclaimLimit() {
    return this._data.eachclaimLimit
  }
  set eachclaimLimit(eachclaimLimit) {
    this._data.eachclaimLimit = eachclaimLimit
  }
  get conveyanceType() {
    return this._data.conveyanceType
  }
  set conveyanceType(conveyanceType) {
    this._data.conveyanceType = conveyanceType
  }
  get conveyance() {
    return this._data.conveyance
  }
  set conveyance(conveyance) {
    this._data.conveyance = conveyance
  }
  get lcNo() {
    return this._data.lcNo
  }
  set lcNo(lcNo) {
    this._data.lcNo = lcNo
  }
  get lcConditions() {
    return this._data.lcConditions
  }
  set lcConditions(lcConditions) {
    this._data.lcConditions = lcConditions
  }
  get voyagepreWay() {
    return this._data.voyagepreWay
  }
  set voyagepreWay(voyagepreWay) {
    this._data.voyagepreWay = voyagepreWay
  }
  get emailReceivers() {
    return this._data.emailReceivers
  }
  set emailReceivers(emailReceivers) {
    this._data.emailReceivers = emailReceivers
  }
  get claimagentCode() {
    return this._data.claimagentCode
  }
  set claimagentCode(claimagentCode) {
    this._data.claimagentCode = claimagentCode
  }
  get claimagentDesc() {
    return this._data.claimagentDesc
  }
  set claimagentDesc(claimagentDesc) {
    this._data.claimagentDesc = claimagentDesc
  }
  get goodsCategory() {
    return this._data.goodsCategoryCode
  }
  set goodsCategory(goodsCategoryCode) {
    this._data.goodsCategoryCode = goodsCategoryCode
  }
  get goodsCategoryDesc() {
    return this._data.goodsCategoryDesc
  }
  set goodsCategoryDesc(goodsCategoryDesc) {
    this._data.goodsCategoryDesc = goodsCategoryDesc
  }
  get goodsName() {
    return this._data.goodsName
  }
  set goodsName(goodsName) {
    this._data.goodsName = goodsName
  }
  get contractNo() {
    return this._data.contractNo
  }
  set contractNo(contractNo) {
    this._data.contractNo = contractNo
  }
  get blNo() {
    return this._data.blNo
  }
  set blNo(blNo) {
    this._data.blNo = blNo
  }
  get blDate() {
    return this._data.blDate
  }
  set blDate(blDate) {
    this._data.blDate = blDate
  }
  get shippingMarks() {
    return this._data.shippingMarks
  }
  set shippingMarks(shippingMarks) {
    this._data.shippingMarks = shippingMarks
  }
  get voyageMode() {
    return this._data.voyageMode
  }
  set voyageMode(voyageMode) {
    this._data.voyageMode = voyageMode
  }
  get upliftType() {
    return this._data.upliftType
  }
  set upliftType(upliftType) {
    this._data.upliftType = upliftType
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get invoiceAmount() {
    return this._data.invoiceAmount
  }
  set invoiceAmount(invoiceAmount) {
    this._data.invoiceAmount = invoiceAmount
  }
  get fromHaulway() {
    return this._data.fromHaulway
  }
  set fromHaulway(fromHaulway) {
    this._data.fromHaulway = fromHaulway
  }
  get toHaulway() {
    return this._data.toHaulway
  }
  set toHaulway(toHaulway) {
    this._data.toHaulway = toHaulway
  }
  get departureInland() {
    return this._data.departureInland
  }
  set departureInland(departureInland) {
    this._data.departureInland = departureInland
  }
  get transportTo() {
    return this._data.transportTo
  }
  set transportTo(transportTo) {
    this._data.transportTo = transportTo
  }
  get insuranceCompanyCode() {
    return this._data.insuranceCompanyCode
  }
  set insuranceCompanyCode(insuranceCompanyCode) {
    this._data.insuranceCompanyCode = insuranceCompanyCode
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get cargodocUuid() {
    return this._data.cargodocUuid
  }
  set cargodocUuid(cargodocUuid) {
    this._data.cargodocUuid = cargodocUuid
  }
  get officeId() {
    return this._data.officeId
  }
  set officeId(officeId) {
    this._data.officeId = officeId
  }
  get mainType() {
    return this._data.mainType
  }
  set mainType(mainType) {
    this._data.mainType = mainType
  }
  get terminationDate() {
    return this._data.terminationDate
  }
  set terminationDate(terminationDate) {
    this._data.terminationDate = terminationDate
  }
  get applicationDate() {
    return this._data.applicationDate
  }
  set applicationDate(applicationDate) {
    this._data.applicationDate = applicationDate
  }
  get inputDate() {
    return this._data.inputDate
  }
  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }
  get mainClauseCode() {
    return this._data.mainClauseCode
  }
  set mainClauseCode(mainClauseCode) {
    this._data.mainClauseCode = mainClauseCode
  }
  get insuranceAmount() {
    return this._data.insuranceAmount
  }
  set insuranceAmount(insuranceAmount) {
    this._data.insuranceAmount = insuranceAmount
  }
  get finalRate() {
    return this._data.finalRate
  }
  set finalRate(finalRate) {
    this._data.finalRate = finalRate
  }
  get additionProportion() {
    return this._data.additionProportion
  }
  set additionProportion(additionProportion) {
    this._data.additionProportion = additionProportion
  }
  get checkDate() {
    return this._data.checkDate
  }
  set checkDate(checkDate) {
    this._data.checkDate = checkDate
  }
  get underwritingDate() {
    return this._data.underwritingDate
  }
  set underwritingDate(underwritingDate) {
    this._data.underwritingDate = underwritingDate
  }
  get issueDate() {
    return this._data.issueDate
  }
  set issueDate(issueDate) {
    this._data.additionProportion = issueDate
  }
  get policyStatusDescription() {
    return this._data.policyStatusDescription
  }
  set policyStatusDescription(policyStatusDescription) {
    this._data.policyStatusDescription = policyStatusDescription
  }
  get applicationNO() {
    return this._data.applicationNO
  }
  set applicationNO(applicationNO) {
    this._data.applicationNO = applicationNO
  }
  get isReIssue() {
    return this._data.isReIssue
  }
  set isReIssue(isReIssue) {
    this._data.isReIssue = isReIssue
  }
  get cancelReason() {
    return this._data.cancelReason
  }
  set cancelReason(cancelReason) {
    this._data.cancelReason = cancelReason
  }
  get jobLob() {
    return this._data.jobLob
  }
  set jobLob(jobLob) {
    this._data.jobLob = jobLob
  }

  get sameApplicant() {
    return this._data.sameApplicant
  }
  set sameApplicant(sameApplicant) {
    this._data.sameApplicant = sameApplicant
  }
}
